import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row, Alert } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "Components/Common/BreadCrumb";
import { S3FileUpload } from "Components/Common/S3FileUpload";
import { toast } from "react-toastify";
import type { RootState } from "store";
import type { ThunkDispatch } from "redux-thunk";
import type { AnyAction } from "redux";
import { importExcelFileThunk } from "slices/lickyc/thunk";

const BULK_UPLOAD_FOLDER = "bulkupload";

const BulkUpload: React.FC = () => {
  const dispatch: ThunkDispatch<RootState, unknown, AnyAction> = useDispatch();
  const { loading, successMsg, errorMsg } = useSelector((state: RootState) => (state as any).lickyc);
  const [uploadError, setUploadError] = useState("");

  useEffect(() => {
    if (successMsg.message && successMsg.id) {
      toast.success(successMsg.message);
    }
  }, [successMsg.message, successMsg.id]);

  useEffect(() => {
    if (errorMsg.message && errorMsg.id) {
      toast.error(errorMsg.message);
    }
  }, [errorMsg.message, errorMsg.id]);

  const handleUploadSuccess = (fileUrl: string) => {
    setUploadError("");
    dispatch(importExcelFileThunk(fileUrl));
  };

  const handleUploadError = (message: string) => {
    setUploadError(message);
  };

  return (
    <div className="page-content" style={{ backgroundColor: "#FCFCFC" }}>
      <Container fluid className="border pt-4 rounded-4 mb-3 ms-3 pe-4 ps-4" style={{ backgroundColor: "#FCFCFC" }}>
        <BreadCrumb title="Bulk Upload" pageTitle="" />
        <Row>
          <Col xs={12}>
            <Card className="border-0 shadow-sm rounded-4" style={{ backgroundColor: "#FFFFFF" }}>
              <CardBody className="p-4">
                <h5 className="card-title mb-2">Import Excel File</h5>
                <p className="text-muted mb-4">
                  Upload an Excel file (.xlsx or .xls) to bulk import data. The file will be uploaded to storage and then processed.
                </p>

                {uploadError && (
                  <Alert color="danger" className="mb-3">
                    {uploadError}
                  </Alert>
                )}

                {loading && (
                  <div className="mb-3 d-flex align-items-center gap-2 text-primary">
                    <div className="spinner-border spinner-border-sm" role="status">
                      <span className="visually-hidden">Processing...</span>
                    </div>
                    <span>Processing your file…</span>
                  </div>
                )}

                <S3FileUpload
                  serviceName={BULK_UPLOAD_FOLDER}
                  onSuccess={handleUploadSuccess}
                  onError={handleUploadError}
                  accept=".xlsx,.xls"
                  buttonLabel="Upload Excel"
                  disabled={loading}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BulkUpload;
